const AUTH_BASE = `/auth/`;

const AUTH_SIGN_IN = `sign-in`;
const AUTH_SIGN_OUT = `sign-out`;

const ADMIN_BASE = `/`;

const ADMIN_BUSINESS = `business`;
const ADMIN_BUSINESS_RFQ_OLD = `quotation-request-old`;
const ADMIN_BUSINESS_RFQ = `quotation-request`;
const ADMIN_BUSINESS_QUOTATION_OLD = `quotation-old`;
const ADMIN_BUSINESS_QUOTATION = `quotation`;
const ADMIN_BUSINESS_ORDER = `order`;

const ADMIN_PROFILE = `profile`;
const ADMIN_PROFILE_V2 = `profile-v2`;

const ADMIN_CATALOG = `catalog`;
const ADMIN_CATALOG_PRODUCT = `product`;
const ADMIN_CATALOG_PROCESSOR = `processor`;

const ADMIN_SUPPLY = "supply";
const ADMIN_SUPPLY_SUPPLIERS = "suppliers";
const ADMIN_LOGISTIC = "logistic";
const ADMIN_SUPPLY_ORDER_MANAGEMENT = "order-management";
const ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER =
  "generate-purchase-order";
const ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER = "purchase-order";
const ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLY_ORDER_PAYMENT_REQUIRED =
  "supply-payment-required";
const ADMIN_SUPPLY_ORDER_MANAGEMENT_INVENTORY = "inventory";
const ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLIER_TRANSACTION =
  "supplier-transaction";
const ADMIN_SUPPLY_ORDER_MANAGEMENT_SHIPMENT_INVOICE = "shipment-invoice";

const ADMIN_ANALYTICS = `analytics`;
const ADMIN_ANALYTICS_ORDER_TRACKER = `order-tracker`;
const ADMIN_ANALYTICS_DASHBOARD = `dashboard`;
const ADMIN_ANALYTICS_TOTAL_ECONOMICS = `total-economics`;

const ADMIN_ORDER_CENTER = `order-center`;
const ADMIN_ORDER_CENTER_ALL = `all`;
const ADMIN_ORDER_CENTER_SALE = `sale`;
const ADMIN_ORDER_CENTER_PROFILE = `profile`;
const ADMIN_ORDER_CENTER_FINANCE = `finance`;
const ADMIN_ORDER_CENTER_LOGISTIC = `logistic`;

const ADMIN_AI_CENTER = `ai-center`;
const ADMIN_AI_AGENT = `agent`;
const ADMIN_AI_CONVERSATION_ACQUISITION = `conversation-acquisition`;
const ADMIN_AI_CONVERSATION_DEVELOPMENT = `conversation-development`;
const ADMIN_AI_DASHBOARD = `dashboard`;
const ADMIN_AI_TAGS = `tags`;
const ADMIN_AI_LEAD_INTAKE = `lead-intake`;
const ADMIN_AI_LEAD_INTAKE_HOST_CONVERSATION = `host-conversations`;

const ADMIN_BOARD = `board`;
const BOARD_SALE = `sale-board`;

export const ROUTES_AUTH = {
  path: AUTH_BASE,
  fullPath: () => AUTH_BASE,

  SIGN_IN: {
    path: AUTH_SIGN_IN,
    fullPath: () => `${AUTH_BASE}${AUTH_SIGN_IN}`,
  },
  SIGN_OUT: {
    path: AUTH_SIGN_OUT,
    fullPath: () => `${AUTH_BASE}${AUTH_SIGN_OUT}`,
  },
};

export const ROUTES_ADMIN = {
  path: ADMIN_BASE,
  fullPath: () => ADMIN_BASE,

  BOARD: {
    path: ADMIN_BOARD,
    fullPath: () => `${ADMIN_BASE}${ADMIN_BOARD}`,

    SALE: {
      path: `${ADMIN_BOARD}/${BOARD_SALE}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_BOARD}/${BOARD_SALE}`,
    },
  },

  BUSINESS: {
    path: `${ADMIN_BUSINESS}/:page`,
    fullPath: (page: string) => `${ADMIN_BASE}${ADMIN_BUSINESS}/${page}`,

    RFQ_OLD: {
      path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ_OLD}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ_OLD}`,

      SHOW: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ_OLD}/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ_OLD}/${uuid}`,
      },
    },

    RFQ: {
      path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ}`,

      SHOW: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ}/generate-quotation/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ}/generate-quotation/${uuid}`,
      },

      CREATE: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ}/new`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_RFQ}/new`,
      },
    },

    QUOTATION_OLD: {
      path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION_OLD}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION_OLD}`,

      SHOW: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION_OLD}?show=:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION_OLD}?show=true&uuid=${uuid}`,
      },
    },

    QUOTATION: {
      path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}`,

      SHOW: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}/${uuid}`,
      },

      CREATE: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}/new`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}/new`,
      },

      UPDATE: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}/update/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_QUOTATION}/update/${uuid}`,
      },
    },

    ORDER: {
      path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_ORDER}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_ORDER}`,

      SHOW: {
        path: `${ADMIN_BUSINESS}/${ADMIN_BUSINESS_ORDER}/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_BUSINESS}/${ADMIN_BUSINESS_ORDER}?show=true&uuid=${uuid}`,
      },
    },
  },

  CATALOG: {
    path: ADMIN_CATALOG,
    fullPath: () => `${ADMIN_BASE}${ADMIN_CATALOG}`,

    PRODUCT: {
      path: `${ADMIN_CATALOG}/${ADMIN_CATALOG_PRODUCT}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_CATALOG}/${ADMIN_CATALOG_PRODUCT}`,

      SHOW: {
        path: `${ADMIN_CATALOG}/${ADMIN_CATALOG_PRODUCT}/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_CATALOG}/${ADMIN_CATALOG_PRODUCT}/${uuid}`,
      },
    },

    PROCESSOR: {
      path: `${ADMIN_CATALOG}/${ADMIN_CATALOG_PROCESSOR}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_CATALOG}/${ADMIN_CATALOG_PROCESSOR}`,
    },
  },

  PROFILE: {
    path: ADMIN_PROFILE,
    fullPath: () => `${ADMIN_BASE}${ADMIN_PROFILE}`,

    SHOW: {
      path: `${ADMIN_PROFILE}/:uuid`,
      fullPath: (uuid: string) => `${ADMIN_BASE}${ADMIN_PROFILE}/${uuid}`,
    },
    SHOW_V2: {
      path: `${ADMIN_PROFILE_V2}/:uuid`,
      fullPath: (uuid: string) => `${ADMIN_BASE}${ADMIN_PROFILE_V2}/${uuid}`,
    },
  },
  SUPPLY: {
    path: ADMIN_SUPPLY,
    fullPath: () => `${ADMIN_BASE}${ADMIN_SUPPLY}`,

    SUPPLIERS: {
      path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}`,

      SUPPLIERS: {
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}/suppliers`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}/suppliers`,

        SHOW: {
          path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}/suppliers/:uuid`,
          fullPath: (uuid: string) =>
            `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}/suppliers/${uuid}`,
        },
      },

      SUPPLIER_FORECASTS: {
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}/supplier-forecasts`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}/supplier-forecasts`,

        SHOW: {
          path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}}/supplier-forecasts/:uuid`,
          fullPath: (uuid: string) =>
            `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_SUPPLIERS}/supplier-forecasts/${uuid}`,
        },
      },
    },

    ADMIN_LOGISTIC: {
      path: `${ADMIN_SUPPLY}/${ADMIN_LOGISTIC}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_LOGISTIC}`,

      SHOW: {
        path: `${ADMIN_SUPPLY}/${ADMIN_LOGISTIC}/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_LOGISTIC}/${uuid}`,
      },
    },

    ORDER_MANAGEMENT: {
      path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/:page`,
      fullPath: (page: string) =>
        `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${page}`,

      GENERATE_PURCHASE_ORDER: {
        page: `${ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER}`,
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER}`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER}`,

        CREATE: {
          path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER}/new`,
          fullPath: () =>
            `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER}/new`,
        },

        UPDATE: {
          path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER}/update/:uuid`,
          fullPath: (uuid: string) =>
            `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_GENERATE_PURCHASE_ORDER}/update/${uuid}`,
        },
      },

      PURCHASE_ORDER: {
        page: `${ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER}`,
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER}`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER}`,

        UPDATE: {
          path: `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER}/update/:uuid`,
          fullPath: (uuid: string) =>
            `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER}/update/${uuid}`,
        },

        SHOW: {
          path: `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER}/:uuid`,
          fullPath: (uuid: string) =>
            `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_PURCHASE_ORDER}/${uuid}`,
        },
      },

      SUPPLY_ORDER_PAYMENT_REQUIRED: {
        page: `${ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLY_ORDER_PAYMENT_REQUIRED}`,
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLY_ORDER_PAYMENT_REQUIRED}`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLY_ORDER_PAYMENT_REQUIRED}`,
      },

      SHIPMENT_INVOICE: {
        page: `${ADMIN_SUPPLY_ORDER_MANAGEMENT_SHIPMENT_INVOICE}`,
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_SHIPMENT_INVOICE}`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_SHIPMENT_INVOICE}`,
      },

      SUPPLIER_TRANSACTION: {
        page: `${ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLIER_TRANSACTION}`,
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLIER_TRANSACTION}`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_SUPPLIER_TRANSACTION}`,
      },

      INVENTORY: {
        page: `${ADMIN_SUPPLY_ORDER_MANAGEMENT_INVENTORY}`,
        path: `${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_INVENTORY}`,
        fullPath: () =>
          `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_INVENTORY}`,

        SHOW: {
          path: `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_INVENTORY}/:uuid`,
          fullPath: (uuid: string) =>
            `${ADMIN_BASE}${ADMIN_SUPPLY}/${ADMIN_SUPPLY_ORDER_MANAGEMENT}/${ADMIN_SUPPLY_ORDER_MANAGEMENT_INVENTORY}/${uuid}`,
        },
      },
    },
  },
  ANALYTICS: {
    path: ADMIN_ANALYTICS,
    fullPath: () => `${ADMIN_BASE}${ADMIN_ANALYTICS}`,

    DASHBOARD: {
      path: `${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_DASHBOARD}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_DASHBOARD}`,
    },

    ORDER_TRACKER: {
      path: `${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_ORDER_TRACKER}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_ORDER_TRACKER}`,
      FILTER: {
        path: `${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_ORDER_TRACKER}`,
        fullPath: (search: string) =>
          `${ADMIN_BASE}${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_ORDER_TRACKER}?search=${search}`,
      },
    },

    TOTAL_ECONOMICS: {
      path: `${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_TOTAL_ECONOMICS}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ANALYTICS}/${ADMIN_ANALYTICS_TOTAL_ECONOMICS}`,
    },
  },
  ORDER_CENTER: {
    path: `${ADMIN_ORDER_CENTER}/:page`,
    fullPath: (page: string) => `${ADMIN_BASE}${ADMIN_ORDER_CENTER}/${page}`,

    ALL: {
      path: `${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_ALL}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_ALL}`,

      SHOW: {
        path: `${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_ALL}/:uuid`,
        fullPath: (uuid: string) =>
          `${ADMIN_BASE}${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_ALL}/${uuid}/`,
      },
    },

    SALE: {
      path: `${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_SALE}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_SALE}`,
    },

    PROFILE: {
      path: `${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_PROFILE}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_PROFILE}`,
    },

    FINANCE: {
      path: `${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_FINANCE}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_FINANCE}`,
    },

    LOGISTIC: {
      path: `${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_LOGISTIC}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_ORDER_CENTER}/${ADMIN_ORDER_CENTER_LOGISTIC}`,
    },
  },

  AI_CENTER: {
    path: `${ADMIN_AI_CENTER}/:page`,
    fullPath: (page: string) => `${ADMIN_BASE}${ADMIN_AI_CENTER}/${page}`,

    AGENT: {
      path: `${ADMIN_AI_CENTER}/${ADMIN_AI_AGENT}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_AI_CENTER}/${ADMIN_AI_AGENT}`,
    },

    CONVERSATION_ACQUISITION: {
      path: `${ADMIN_AI_CENTER}/${ADMIN_AI_CONVERSATION_ACQUISITION}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_AI_CENTER}/${ADMIN_AI_CONVERSATION_ACQUISITION}`,
    },

    CONVERSATION_DEVELOPMENT: {
      path: `${ADMIN_AI_CENTER}/${ADMIN_AI_CONVERSATION_DEVELOPMENT}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_AI_CENTER}/${ADMIN_AI_CONVERSATION_DEVELOPMENT}`,
    },

    TAGS: {
      path: `${ADMIN_AI_CENTER}/${ADMIN_AI_TAGS}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_AI_CENTER}/${ADMIN_AI_TAGS}`,
    },

    DASHBOARD: {
      path: `${ADMIN_AI_CENTER}/${ADMIN_AI_DASHBOARD}`,
      fullPath: () => `${ADMIN_BASE}${ADMIN_AI_CENTER}/${ADMIN_AI_DASHBOARD}`,
    },
  },

  LEAD_INTAKE: {
    path: `${ADMIN_AI_LEAD_INTAKE}/:page`,
    fullPath: (page: string) => `${ADMIN_BASE}${ADMIN_AI_LEAD_INTAKE}/${page}`,

    HOST_CONVERSATION: {
      path: `${ADMIN_AI_LEAD_INTAKE}/${ADMIN_AI_LEAD_INTAKE_HOST_CONVERSATION}`,
      fullPath: () =>
        `${ADMIN_BASE}${ADMIN_AI_LEAD_INTAKE}/${ADMIN_AI_LEAD_INTAKE_HOST_CONVERSATION}`,
    },
  },
};
